// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3D8MB4Y3RPMRyk4-66ylAv","notFoundHome":"_3_pRrJoHUwkoptDqkh1h_4","errorPage":"D4Br_y28PBfJL_zyC6X7Q","inner":"_2af1cyOp_Yid2i2Qp1qckH"};